const toolbar = [
  "searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  undo redo removeformat",
  "link  charmap preview  insertdatetime  forecolor backcolor fontsizeselect uploadImage emoticons",
];
export default toolbar;
